export const AUTH_URL = process.env.PRIVATE_PLANE
  ? `${window.location.protocol}//${window.location.host}/login-api`
  : 'https://api.synthetica.ai';
export const BASE_URL = `${window.location.protocol}//${window.location.host}`;
export const EMAIL_US_URL = 'http://34.107.116.82:5000/sendMail';
